import { Box, FormControl, FormGroup, FormLabel, TextField } from "@mui/material";
import { AmazonSettings, OTPEnum } from "../../api";
import { PasswordField } from "../controls";
import { OTPEnumList } from "./OTPEnumList";
import { DialpadSettingsControl } from "./DialpadSettingsControl";
import { useCallback, useEffect, useReducer, useState } from "react";

export interface AmazonSettingsControlProps {
  settings?: AmazonSettings;
  onChange: (settings: Partial<AmazonSettings>) => void;
}

export const AmazonSettingsControl = (props: AmazonSettingsControlProps) => {
  const { settings, onChange } = props;

  useEffect(() => {
  }, [settings]);

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Amazon settings</FormLabel>
      <FormGroup>
        <TextField label="Email" variant="standard" value={settings?.email ?? ""} onChange={(e) => onChange({ email: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Market" variant="standard" helperText="if not set United States is default" value={settings?.market ?? ""} onChange={(e) => onChange({ market: e.target.value })} />
        <Box sx={{ p: 1 }} />
        <OTPEnumList value={settings?.otp ?? OTPEnum.None} onChange={(value) => onChange({ otp: value })} />
        {settings?.otp === OTPEnum.Dialpad && (
          <Box>
            <Box sx={{ p: 1 }} />
            <DialpadSettingsControl settings={settings?.dialpad ?? ({} as any)} onChange={(value) => onChange({ dialpad: value as any })} />
          </Box>
        )}
      </FormGroup>
    </FormControl>
  );
};
